import React from 'react'
import { Col } from 'reactstrap'

export default function SelectProgressBar ({selectorName, state}) {
  return (
    <Col className='prog-bar'>
      <div className='org-info-select-prog'>
        <span className={state[selectorName] ? 'outer-circle selected' : 'outer-circle'}>
          <span className="inner-circle"></span>
        </span>
        <br />
        <span className={state[selectorName] ? 'connecting-line selected' : 'connecting-line'}>
        </span>
      </div>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectProgressBar.js